import { Divider } from "@mui/joy";
import { useFormContext } from "react-hook-form";
import { useGetTiposVisitaQuery } from "../../../../api/filter/dataFilterApi";
import { AddCommentsForm } from "./AddCommentsForm";
import { AddedVisitas } from "./AddedVisitas";
import { ChangeStageComment } from "../../../../types/pipeline";
import { Dispatch, SetStateAction } from "react";
import { ValidFormCompnentes } from "src/features/deals/ChangeDealStage/types";

interface Props {
    setCurrentForm: Dispatch<SetStateAction<ValidFormCompnentes>>;
}

export function ConfirmDealForm({ setCurrentForm }: Props) {
    const { data: tiposVisita } = useGetTiposVisitaQuery();

    const { 
        register,
        watch,
        setValue,
        formState: { errors: errors }
    } = useFormContext<ChangeStageComment>();

    const visitasAgregadas = watch("visitas");

    return (
        <div className="mb-3">
            <p className="text-lg font-semibold">Informacion de la campaña</p>

            <div className="grid grid-cols-2 gap-x-2">
                <div>
                    <label className="text-sm font-semibold">Tipo de campaña</label>
                    <select 
                        {...register("tipoCampana", {
                            min: 1
                        })}
                        aria-invalid={errors.tipoCampana ? "true" : "false"}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm">
                        <option value={0} hidden>Seleccionar</option>
                        {tiposVisita?.map((tipo, index) => (
                        <option value={tipo.id} key={index}>{tipo.nombre}</option>
                        ))}
                    </select>

                    {errors.tipoCampana?.type === "min" && (
                        <p className="valErrorText text-sm">{"El tipo de campaña es requerido"}</p>
                    )}

                </div>
            </div>

            <div className="grid grid-cols-2 gap-x-2">
                <div>
                    <label className="text-sm font-semibold">Fecha de inicio</label>
                    <input 
                        {...register("fechaInicio", {
                            required: "La fecha de inicio es requerida",
                            validate: {
                                fechaInicioIsBeforeFin: (fechaInicio, formValues) => {
                                    if(formValues.fechaInicio === undefined ||
                                        formValues.fechaFin < fechaInicio)
                                        return false;

                                    return true;
                                }
                            },
                        })}
                        type="date"
                        aria-invalid={errors.fechaInicio ? "true" : "false"}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"
                        />

                    {errors.fechaInicio?.type === "required" && (
                        <p className="valErrorText text-sm">{errors.fechaInicio?.message}</p>
                    )}
                    {errors.fechaInicio?.type === "fechaInicioIsBeforeFin" && (
                        <p className="valErrorText text-sm">La fecha de inicio no puede ser mayor a la de fin</p>
                    )}

                </div>

                <div>
                    <label className="text-sm font-semibold">Fecha de fin</label>
                    <input 
                        {...register("fechaFin", {
                            required: "La fecha de fin es requerida",
                            validate: {
                                fechaFinIsAfterInicio: (fechaFin, formValues) => {
                                    if(formValues.fechaFin === undefined ||
                                        fechaFin < formValues.fechaInicio)
                                        return false;

                                    return true;
                                }
                            }
                        })}
                        type="date"
                        aria-invalid={errors.fechaFin ? "true" : "false"}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"
                        />

                    {errors.fechaFin?.type === "required" && (
                        <p className="valErrorText text-sm">{errors.fechaFin?.message}</p>
                    )}
                    {errors.fechaFin?.type === "fechaFinIsAfterInicio" && (
                        <p className="valErrorText text-sm">La fecha de fin no puede ser antes que la de inicio</p>
                    )}

                </div>
            </div>

            <Divider sx={{ marginTop: 2, marginBottom: 2 }} ><p className="text-sm font-semibold">Visitas</p></Divider>

            <AddedVisitas 
                visitasAgregadas={visitasAgregadas}
                setVisitasAgregadas={(visitas) => {
                    setValue("visitas", visitas);
                }} 
                setCurrentComponent={setCurrentForm}/>

            <AddCommentsForm
                register={register}
                errors={errors} />
        </div>
    );
}
